<template>
<el-form  :rules="rules" ref="loraForm" :model="comms" label-width="50%" label-position="left">
    
   
  </el-form>
</template>

<script>
import { post } from "../../../../../API/cloudFunctions";

export default {
  created() {
    if (this.$store.getters.smtpConfig) {
      this.smtp = this.$store.getters.smtpConfig;
    }
  },
  name: "lora",
  data() {
    return {
      comms: {},
      rules: {
        name: {
          required: true,
          message: "Please provide a SMTP mail server!"
        },
        apn: { required: true },
        band: { required: true },
        operator: { required: true },
        port: { required: true },
        udp_addr: { required: true },
        udp_port: { required: true }
      },
      loading: false,
      disablePassword: true,
      sendingTestEmail: false,
      sent: false
    };
  },
  methods: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/configuration/lora.vue